<div class="mat-title p-4 mb-0">{{ title }}</div>
<mat-selection-list [multiple]="false">
  <mat-list-option *ngFor="let element of elementsList" (click)="bottomSheetRef.dismiss(element)">
    <p>{{ element.name }}</p>
  </mat-list-option>
</mat-selection-list>
